import React, { useState } from 'react';
import { UserIcon, TrendingUpIcon, ClockIcon, QuoteIcon } from 'lucide-react';
export const TestimonialsSection = () => {
  const [activeVideoIndex, setActiveVideoIndex] = useState(0);
  const testimonials = [{
    name: 'Michael K.',
    role: 'Senior Frontend Engineer',
    company: 'PayPal',
    thoughts: 'I was skeptical about coaching at first, but the ROI was incredible. The mock interviews and feedback were game-changing.',
    timeline: '2 months',
    increase: '200% compensation increase'
  }, {
    name: 'Habib Q.',
    role: 'Senior Frontend Engineer',
    company: 'Calendly',
    thoughts: 'I went from having to go into the Amazon office 5 days a week, to securing a fully remote role with a stronger compensation.',
    timeline: '3 months',
    increase: '$300,000+ total comp, fully remote'
  }, {
    name: 'Steven',
    role: 'Senior ML Manager',
    company: 'Meta',
    thoughts: 'In 3 months, we were able to double my comp, and negotiated up $150k from the initial offer.',
    timeline: '3 months',
    increase: '$840k total comp from $400k, $150k up from original offer'
  }, {
    name: 'Marcel D.',
    role: 'Senior Software Engineer',
    company: 'Flex, DoorDash, Smartsheet',
    thoughts: 'I walked away with three offers—including one two levels above my previous role. ApplyPass gave me the clarity and tools I needed to finally break through.',
    timeline: '2 months',
    increase: '85% compensation increase'
  }, {
    name: 'Mitchell N',
    role: 'Machine Learning Engineer',
    company: '',
    thoughts: 'I got the coaching I needed to break into Machine Learning with 2 years of experience, and with a significant increase in comp.',
    timeline: '5 months',
    increase: '$95K compensation increase'
  }, {
    name: 'John B. L.',
    role: 'Staff Software Engineer',
    company: 'Apple',
    thoughts: "The coaching helped me make a really strong case with the hiring managers - even the recruiters couldn't believe that they approved the offer.",
    timeline: '2 months',
    increase: '$842,000 total Compensation',
    image: ''
  }, {
    name: 'Joey',
    role: 'Support Engineering Manager',
    company: 'Replit',
    thoughts: 'Working with Michelle helped me switched to a startup leadership role at a fast-growing AI company.',
    timeline: '3 months',
    increase: '2x Total compensation increase - $225k base, $400 TC',
    image: ''
  }, {
    name: 'Tyler',
    role: 'Support Machine Learning Engineer',
    company: 'Lattice',
    timeline: '3 months',
    thoughts: "I have 22+ years of experience, but don't think I could've landed such a big jump from my previous compensation on my own.",
    increase: 'From $170k to $280k base, $504k total comp',
    image: ''
  }, {
    name: 'William',
    role: 'Staff iOS Engineer',
    company: 'Venmo',
    timeline: '4.5 weeks',
    thoughts: "It takes an average of 6-12 months to land a job these days - but not only did David and Michelle help me secure my current offer in 4.5 weeks, I've easily doubled my comp.",
    increase: 'From $180k to $280k, $40k more than original offer',
    image: ''
  }, {
    name: 'Becca',
    role: 'Senior Full Stack Engineer',
    company: 'Gusto',
    timeline: '3 months',
    thoughts: "It takes an average of 6-12 months to land a job these days - but not only did David and Michelle help me secure my current offer in 4.5 weeks, I've easily doubled my comp.",
    increase: 'From $165,000 to $303,000',
    image: ''
  }, {
    name: 'Julissa C.',
    role: 'Senior Software Engineer in AI',
    company: 'Polly',
    thoughts: 'ApplyPass and the coaching team got me into the AI space without taking a pay cut. Unreal.',
    timeline: '1 month',
    increase: 'Pivoted without a paycut'
  }];
  return <section className="w-full bg-[#231232] py-24" id="testimonials" data-id="element-244">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-245">
        <div className="text-center mb-16" data-id="element-246">
          <span className="inline-block px-4 py-1.5 bg-[#FFC501]/10 text-[#FFC501] rounded-full text-sm font-medium mb-4" data-id="element-247">
            PROVEN RESULTS
          </span>
          <h2 className="text-4xl sm:text-5xl font-outfit font-bold mb-6 text-white" data-id="element-248">
            Success Stories
          </h2>
          <div className="h-1 w-24 bg-gradient-to-r from-[#FFC501] to-[#DF4425] mx-auto rounded-full mb-6" data-id="element-249"></div>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-250">
            Real results from engineers who've transformed their careers
          </p>
        </div>
        {/* Results Dashboard */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16" data-id="element-251">
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-8 text-center hover-card" data-id="element-252">
            <TrendingUpIcon size={32} className="text-[#FFC501] mb-4 mx-auto" data-id="element-253" />
            <h3 className="text-2xl font-outfit font-bold mb-2 text-white" data-id="element-254">
              127%
            </h3>
            <p className="text-gray-300" data-id="element-255">Average compensation increase</p>
          </div>
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-8 text-center hover-card" data-id="element-256">
            <UserIcon size={32} className="text-[#FFC501] mb-4 mx-auto" data-id="element-257" />
            <h3 className="text-2xl font-outfit font-bold mb-2 text-white" data-id="element-258">
              100%
            </h3>
            <p className="text-gray-300" data-id="element-259">Success rate in getting offers</p>
          </div>
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-8 text-center hover-card" data-id="element-260">
            <ClockIcon size={32} className="text-[#FFC501] mb-4 mx-auto" data-id="element-261" />
            <h3 className="text-2xl font-outfit font-bold mb-2 text-white" data-id="element-262">
              3-4 Months
            </h3>
            <p className="text-gray-300" data-id="element-263">Average time to first offer</p>
          </div>
        </div>
        {/* Case Studies */}
        <div className="grid md:grid-cols-2 gap-8" data-id="element-264">
          {testimonials.map(testimonial => <div key={testimonial.name} className="relative backdrop-blur-xl bg-white/5 rounded-xl p-8 border border-white/10 hover-card" data-id="element-265">
              <div className="flex items-center gap-4 mb-6" data-id="element-266">
                {testimonial.image ? <img src={testimonial.image} alt={testimonial.name} className="w-16 h-16 rounded-full object-cover border-2 border-white/20" data-id="element-267" /> : <div className="w-16 h-16 rounded-full border-2 border-white/20 bg-white/5 flex items-center justify-center" data-id="element-268">
                    <UserIcon size={32} className="text-white/40" data-id="element-269" />
                  </div>}
                <div data-id="element-270">
                  <h4 className="font-outfit font-bold text-xl text-white" data-id="element-271">
                    {testimonial.name}
                  </h4>
                  <p className="text-white/60" data-id="element-272">
                    {testimonial.role} at {testimonial.company}
                  </p>
                </div>
              </div>
              <div className="space-y-4" data-id="element-273">
                <div data-id="element-274">
                  <h5 className="text-sm font-medium uppercase tracking-wider text-white/40 mb-2" data-id="element-275">
                    The Experience
                  </h5>
                  <p className="text-white/80 text-lg" data-id="element-276">
                    {testimonial.thoughts}
                  </p>
                </div>
                <div data-id="element-277">
                  <h5 className="text-sm font-medium uppercase tracking-wider text-white/40 mb-2" data-id="element-278">
                    Timeline to Offer
                  </h5>
                  <p className="text-white/80 font-medium" data-id="element-279">
                    {testimonial.timeline}
                  </p>
                </div>
                <div className="relative" data-id="element-280">
                  <div className="absolute inset-0 bg-gradient-to-r from-[#FFC501]/10 to-[#6805DA]/10 rounded-lg blur" data-id="element-281" />
                  <div className="relative bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg p-4" data-id="element-282">
                    <h5 className="text-sm font-medium uppercase tracking-wider text-white/40 mb-2" data-id="element-283">
                      The Result
                    </h5>
                    <p className="text-white font-bold text-xl bg-gradient-to-r from-[#FFFCE7] to-[#FFC501] bg-clip-text text-transparent" data-id="element-284">
                      {testimonial.increase}
                    </p>
                  </div>
                </div>
              </div>
              {/* Subtle corner gradient */}
              <div className="absolute bottom-0 right-0 w-32 h-32 bg-gradient-to-r from-[#6805DA]/5 to-transparent rounded-br-xl" data-id="element-285" />
            </div>)}
        </div>
      </div>
    </section>;
};